import { Box, Flex } from "components/ui";
import { Navigate, Route, Routes } from "react-router-dom";
import routes from "routes";
import { gradients } from "theme/gradients";

export default function Auth() {
  const getRoutes = (routes: RoutesType[]): any => {
    return routes.map((prop, key) => {
      if (prop.layout === "/auth") {
        return (
          <Route path={`/${prop.path}`} element={prop.component} key={key} />
        );
      } else {
        return null;
      }
    });
  };

  document.documentElement.dir = "ltr";

  return (
    <Flex h="100vh" w="100vw" overflow="hidden">
      {/* Left Side - Form */}
      <Flex
        w={{ base: "100%", lg: "50%" }}
        bg={{ base: "white", _dark: "gray.900" }}
        align="center"
        justify="center"
        p={8}
      >
        <Box w="full" maxW="480px">
          <Routes>
            {getRoutes(routes)}
            <Route path="/" element={<Navigate to="/auth/sign-in" replace />} />
            <Route path="*" element={<Navigate to="/auth/sign-in" replace />} />
          </Routes>
        </Box>
      </Flex>

      {/* Right Side - strikeUp brand gradient (heroBlue: dark navy → electric blue) */}
      <Box
        w="50%"
        h="100vh"
        bgImage={gradients.heroBlue}
        display={{ base: "none", lg: "block" }}
      />
    </Flex>
  );
}
